const data = {
  site: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '30'
    }, {
      prop: 'siteId',
      label: '站点编号'
    }, {
      prop: 'siteName',
      label: '站点名称'
    }, {
      prop: 'num',
      label: '站点车辆'
    }]
  },
  history: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'createTime',
      label: '时间'
    }, {
      prop: 'siteName',
      label: '站点名称'
    }, {
      prop: 'num',
      label: '站点车辆',
      sortable: true
    }, {
      prop: 'status',
      label: '站点状态',
      filters: true
    }]
  },
  companyHistory: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'brandId',
      label: '品牌名称'
    }, {
      prop: 'userName',
      label: '操作人'
    }, {
      prop: 'fileType',
      label: '导入类型'
    }, {
      prop: 'fileUrl',
      label: '导入内容',
      width: '100'
    }, {
      prop: 'createTime',
      label: '时间',
      width: '150'
    }]
  },
  bikeMonitor: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'brandName',
      label: '品牌名称'
    }, {
      prop: 'quantity_approved',
      label: '核定数量'
    }, {
      prop: 'recorded_number',
      label: '已备案数'
    }, {
      prop: 'warn',
      label: '备案异常'
    }, {
      prop: 'abnormal',
      label: '未备案车'
    }]
  },
  warn: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    },
      {
        prop: 'licenseCode',
        label: '车牌号'
      }, {
        prop: 'frameCode',
        label: '车架编码'
      }, {
        prop: 'bikeId',
        label: '车身二维码编号'
      }, {
        prop: 'imeiCode',
        label: 'MAC码'
      }
    ]
  },
  abnormal: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    },
      {
        prop: 'bikeId',
        label: '车身二维码编号',
        width: '200'
      },
      {
        prop: 'createTime',
        label: '创建时间',
        width: '200'
      }
    ]
  },
  siteRank: [{
    prop: 'index',
    label: '排名'
  }, {
    prop: 'siteName',
    label: '站点名称',
    width: '200'
  }, {
    prop: 'rentNum',
    label: '租车',
    renderHeaderType: 'rentNum'
  }, {
    prop: 'returnNum',
    label: '还车',
    renderHeaderType: 'returnNum'
  }],
  notupload: [{
    prop: 'brandName',
    label: '品牌'
  }, {
    prop: 'count',
    label: '扫一扫巡查'
  }, {
    prop: 'mac_count',
    label: '嗅探巡查'
  }],
  count: [{
    prop: 'index',
    label: '序号',
    width: '40'
  },
    {
      prop: 'bikeId',
      label: '车辆编码'
    }, {
      prop: 'miUserName',
      label: '操作人'
    }, {
      prop: 'createTime',
      label: '时间'
    }],
  mac_count: [{
    prop: 'index',
    label: '序号',
    width: '50'
  },
    {
      prop: 'bikeMac',
      label: '车辆MAC'
    }, {
      prop: 'miUserName',
      label: '操作人'
    }, {
      prop: 'createTime',
      label: '时间'
    }, {
      prop: 'bikeId',
      label: '车辆编码'
    }]
}

export default data
